import { render } from "./PasswordUpdate.vue?vue&type=template&id=05ddf0f5"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__